<template>
  <button
    @click="$emit('click')"
    :disabled="$attrs.disabled"
    class="inline-block py-1 px-3 focus:outline-none"
    :class="{
      'bg-gray-100 hover:bg-gray-100 cursor-default': $attrs.disabled,
      'hover:bg-blue-400': !$attrs.disabled,
      'bg-blue-400': active,
      'bg-white': !active,
    }"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    active: Boolean,
  },
};
</script>
